import styled from 'styled-components';
import Image from '@stencil/image';

import {PrimaryLink} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';

export const DealsDiscoveryCard = styled.section(
  props => `
  display:flex;
  width:100%;
  justify-content:space-between;
  background: ${props.theme.colors.goWhite.base};
  padding: ${props.theme.spacing.custom(8)};
  border: 1px solid #E5EDF6;
  border-radius:${props.theme.misc.borderRadius.custom(12)};
  margin-bottom: ${props.theme.spacing.custom(8)};
  margin-top: ${props.theme.spacing.custom(8)};
  cursor:pointer;
  `,
);

export const Know_More_Link = styled(PrimaryLink)(
  props => `
    font-weight: 600;
    width:60%;
    display: flex;
    align-items: center;
    `,
);

export const Bank_Box = styled.div(
  props => `
    display:flex;
    width:7rem;
    background: #F6F6F6;
    border: 1px solid rgba(0, 50, 149, 0.24);
    border-radius: 8px;
    padding:${props.theme.spacing.large} ${props.theme.spacing.small};
    margin-right:${props.theme.spacing.custom(8)};
    justify-content: center;
    align-items: flex-start;
    `,
);

export const Bank_Type_Img = styled.img(
  props => `
    object-fit: cover;
    // height: 0.8rem;
    width:25.8px;
    `,
);

export const Code_Applied_Header = styled.p`
  ${textSizes.SmallW3}
  color: #003295;
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const Code_Applied_SubHead = styled.span(
  props => `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
    `,
);

export const Amount_Saved = styled.p(
  props => `
      color: #003295;
    margin-bottom:${props.theme.spacing.small};
      `,
);

export const RoomImage = styled(Image)(
  props => `
    width:100%;
    width:9.1rem;
    height: 8.7rem;
    border-radius:${props.theme.misc.borderRadius.custom(12)};
      `,
);

export const DealsDiscoveryBaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    justify-content:center;
    width:100%;
    `,
);
